<script lang="ts">
    import { Col } from "sveltestrap";
    import { VerticalScroll } from "../../../utils/Constant/Constant";
    import Card from "../../Core/Card.svelte";
    import data from "../../../Data/ComponentData/BonusUi/Scrollable/Scrollable.json"
</script>
<Col sm="6">
    <Card cardHeaderprops="pb-0" headerTitle={VerticalScroll}>
      <div slot="contentbody">
        <div class="vertical-scroll scroll-demo">
          {#each data.scrolldata as scrollItem}
            <p>{scrollItem.content}</p>
          {/each}
        </div>
      </div>
    </Card>
</Col>